(function(){
"use strict";
try{
 var base=document.querySelector('link[href*="dema-collection.css"]');
 if(base){
  ["dema-collection-fix.css","dema-collection-compatta.css"].forEach(function(f){
   var l=document.createElement("link");
   l.rel="stylesheet";
   l.href=base.href.replace("dema-collection.css",f);
   document.head.appendChild(l);
  });
 }
}catch(e){}

/* Un foglio di un'app installata sovrascrive posizione e colori degli
   elementi dentro la card, e non e' raggiungibile dalla nostra cascata.
   Qui scriviamo solo cio' che l'app rompe. */
var TONI={
 nuovo:"linear-gradient(135deg,#5b6cff,#00d4b8)",
 caldo:"linear-gradient(135deg,#f5a623,#e8890b)",
 base:"linear-gradient(135deg,#16234a,#1f2f5e)"
};
function piccolo(){return window.matchMedia("(max-width:640px)").matches}
function applica(el,reg){for(var k in reg)el.style.setProperty(k,reg[k],"important")}

function vantaggi(){
 var el=document.querySelectorAll(".dcol .perks");
 for(var i=0;i<el.length;i++){
  var li=el[i].querySelectorAll("li");
  for(var j=0;j<li.length;j++){
   if(/batteri/i.test(li[j].textContent)){ li[j].remove(); break; }
  }
 }
}

/* La pastiglia del risparmio deve stare SEMPRE sotto al prezzo di
   lancio. Lasciata nel flusso del testo finiva accanto sulle card con
   il prezzo corto e sotto su quelle con il prezzo lungo. */
function risparmio(){
 var v=document.querySelectorAll(".dcol .vecchio");
 for(var i=0;i<v.length;i++){
  applica(v[i],{
   display:"grid",
   "grid-template-columns":"auto auto 1fr",
   "grid-template-areas":'"et prezzo info" "risparmi risparmi risparmi"',
   "align-items":"center",
   "justify-items":"start",
   "column-gap":"7px",
   "row-gap":"5px"
  });
  var et=v[i].querySelector(".et");
  var s=v[i].querySelector("s");
  var info=v[i].querySelector(".info");
  var r=v[i].querySelector(".risparmi");
  if(et)applica(et,{"grid-area":"et"});
  if(s)applica(s,{"grid-area":"prezzo"});
  if(info)applica(info,{"grid-area":"info","justify-self":"start"});
  if(r)applica(r,{"grid-area":"risparmi"});
 }
}

function etichette(){
 var m=piccolo();

 var card=document.querySelectorAll(".dcol .card");
 for(var z=0;z<card.length;z++)applica(card[z],{isolation:"isolate","z-index":"0",position:"relative"});

 var e=document.querySelectorAll(".dcol .dcolet");
 for(var i=0;i<e.length;i++){
  var el=e[i];
  var tono=el.classList.contains("caldo") ? TONI.caldo
         : el.classList.contains("nuovo") ? TONI.nuovo : TONI.base;
  applica(el,{
   position:"absolute", top:m?"9px":"12px", left:m?"9px":"12px",
   right:"auto", bottom:"auto", width:"auto", height:"auto", "z-index":"2",
   color:"#fff", "font-size":m?"8.5px":"10.5px", "font-weight":"800",
   padding:m?"3px 7px":"5px 11px", "border-radius":m?"5px":"7px",
   "line-height":"1.2", background:tono,
   "box-shadow":"0 4px 12px rgba(22,35,74,.35)",
   "white-space":"nowrap", "pointer-events":"none"
  });
 }

 var med=document.querySelectorAll(".dcol .media");
 for(var d=0;d<med.length;d++)applica(med[d],{display:"flex","align-items":"center","justify-content":"center",position:"relative","z-index":"0"});
 var img=document.querySelectorAll(".dcol .media img");
 for(var j=0;j<img.length;j++)applica(img[j],{
  position:"static", top:"auto", left:"auto", right:"auto", bottom:"auto",
  "z-index":"1", margin:"auto", "align-self":"center",
  "max-height":m?"72%":"78%", height:"auto", width:"auto",
  "max-width":"100%", "object-fit":"contain"
 });
 var gl=document.querySelectorAll(".dcol .glow");
 for(var g=0;g<gl.length;g++)gl[g].style.setProperty("z-index","0","important");

 var h=document.querySelectorAll(".dcol .corpo h3");
 for(var t=0;t<h.length;t++)applica(h[t],{"font-size":m?"15px":"21px"});
 var li=document.querySelectorAll(".dcol .perks li");
 for(var v=0;v<li.length;v++)applica(li[v],{"font-size":m?"9.5px":"13px"});

 var et=document.querySelectorAll(".dcol .vecchio .et");
 for(var n=0;n<et.length;n++)applica(et[n],{color:"#9aa3b2","font-size":m?"10px":"11.5px","font-weight":"600"});
 var s=document.querySelectorAll(".dcol .vecchio s");
 for(var q=0;q<s.length;q++)applica(s[q],{color:"#8d95a5","font-size":m?"11.5px":"13px","font-weight":"600",opacity:"1"});
 var r=document.querySelectorAll(".dcol .risparmi");
 for(var p=0;p<r.length;p++)applica(r[p],{
  color:"#00917f", background:"#d8f5f0", "background-image":"none",
  "font-size":m?"9px":"11.5px", padding:m?"2px 6px":"3px 9px",
  "font-weight":"800", "border-radius":"12px",
  "white-space":"nowrap", display:"inline-block"
 });

 var da=document.querySelectorAll(".dcol .ora .et");
 for(var a=0;a<da.length;a++)applica(da[a],{"font-size":m?"12.5px":"15px",color:"#6b7280"});
 var num=document.querySelectorAll(".dcol .ora .num");
 for(var b=0;b<num.length;b++)applica(num[b],{"font-size":m?"20px":"28px",color:"#16234a"});

 var kl=document.querySelectorAll(".dcol .kl,.dcol .yo");
 for(var c2=0;c2<kl.length;c2++)applica(kl[c2],{"font-size":m?"9px":"11.5px",padding:m?"3px 10px":"4px 13px"});
 var imp=document.querySelectorAll(".dcol .imp");
 for(var w=0;w<imp.length;w++)applica(imp[w],{"font-size":m?"10.5px":"13px",color:"#16234a"});
 var lab=document.querySelectorAll(".dcol .rate .et");
 for(var x=0;x<lab.length;x++)applica(lab[x],{"font-size":m?"9.5px":"11.5px",color:"#6b7280"});
 var btn=document.querySelectorAll(".dcol .btn");
 for(var y=0;y<btn.length;y++)applica(btn[y],{"font-size":m?"11.5px":"14.5px"});

 risparmio();
}

function rate(){
 if(!window.DemaRate)return;
 var caselle=document.querySelectorAll(".dcol .rate[data-prezzo]");
 for(var i=0;i<caselle.length;i++){
  var c=caselle[i];
  if(c.dataset.fatto)continue;
  var tot=parseFloat(c.getAttribute("data-prezzo"))||0;
  if(!tot)continue;
  var html='<span class="et">Tuo in comode rate da:</span>';
  var k=window.DemaRate.klarna(tot);
  if(k)html+='<div class="riga"><span class="kl">Klarna</span><span class="imp">'+window.DemaRate.euro(k.tre)+' x3</span></div>';
  var y=window.DemaRate.younited(tot);
  if(y)html+='<div class="riga"><span class="yo">Younited</span><span class="imp">'+window.DemaRate.euro(y.rata)+'/mese</span></div>';
  c.innerHTML=html;
  c.dataset.fatto="1";
 }
}

function info(){
 var box=document.getElementById("dcolInfo");
 if(!box)return;
 document.addEventListener("click",function(e){
  var b=e.target.closest(".dcol .vecchio .info");
  if(b){e.preventDefault();box.classList.add("on");return}
  if(e.target.closest("#dcolInfo [data-chiudi]"))box.classList.remove("on");
 });
}

function avvia(){vantaggi();etichette();rate();info()}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",avvia);
else avvia();
addEventListener("load",function(){vantaggi();etichette();rate()});
addEventListener("resize",etichette);
setTimeout(function(){vantaggi();etichette()},600);
setTimeout(etichette,1500);
})();
